export default __webpack_public_path__ + "static/media/image.sha-web-design.015999d2.png";